import { Monitor, Moon, Sun } from "lucide-react";
import { setTheme, useTheme, type Theme } from "../lib/theme";

export function ThemeSwitcher() {
  const theme = useTheme();
  const Icon = { system: Monitor, light: Sun, dark: Moon }[theme];
  return (
    <label className="theme-control" title={`Theme: ${theme}`}>
      <Icon size={16} aria-hidden="true" />
      <select
        aria-label="Theme"
        value={theme}
        onChange={(event) => setTheme(event.target.value as Theme)}
      >
        <option value="system">System</option>
        <option value="light">Light</option>
        <option value="dark">Dark</option>
      </select>
    </label>
  );
}
